import { DialogKldrProps } from "../../../ComponentInterface";
import smetaAxios from "../../../SmetaAxios";
import { Prefixes } from "../../Tools/ProjectX";
import { getRightsData } from "../../Tools/Tools";
import { parseColumns } from "../GridTools/parseColumnTools";
import { createGrid, createRecordSource } from "../rcsgrid";

export async function kladrGrid(grid: createGrid, source: createRecordSource, props: DialogKldrProps, data: any) {
  const json = await kladrtGetTable(props);
  source.onHandleRequest = handleRequest(props, data);
  source.caseSensitive = false;
  await source.open();
  if (json) {
    source.rights = getRightsData(json.Rights || "0");
    const columns = parseColumns(json);
    grid.setColumns(columns);
  } else grid.defaultColumns = true;
  await grid.setSource(source);
  await grid.refreshSource(props.RecordIndex);
  await grid.updateGridSize();
}

function handleRequest(props: DialogKldrProps, data: any) {
  return (request) => {
    return smetaAxios.post("HandleTable", request, {
      prefix: Prefixes.kladr,
      params: { ObjType: props.ObjType, Code: props.Code },
      loadMask: true,
    });
  };
}

const kladrtGetTable = (props: DialogKldrProps) => {
  return smetaAxios.get("GetTableLayout", {
    prefix: Prefixes.kladr,
    params: { ObjType: props.ObjType, Code: props.Code },
    loadMask: true,
  }) as Promise<{ Rights?: string; JSONType?: string; Columns?: Record<string, string>[] }>;
};
